import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_SCHEDULE_AREAS,
    FETCH_ACTIVE_SCHEDULE_AREAS,
    FETCH_SCHEDULE_AREA
} from './types';

const showScheduleAreaError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Không thể xử lý khu vực làm việc.');
};

export const fetchScheduleAreas = (filters = {}) => dispatch => api
    .get('/schedule-areas', { params: filters })
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_AREAS, payload: res.data.data });
        return res.data;
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });

export const fetchActiveScheduleAreas = () => dispatch => api
    .get('/schedule-areas/by-active')
    .then(res => {
        dispatch({ type: FETCH_ACTIVE_SCHEDULE_AREAS, payload: res.data.data || [] });
        return res.data.data || [];
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });

export const fetchScheduleArea = id => dispatch => api
    .get(`/schedule-areas/${id}`)
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_AREA, payload: res.data.data });
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });

export const createScheduleArea = data => () => api
    .post('/schedule-areas', data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });

export const updateScheduleArea = (id, data) => () => api
    .put(`/schedule-areas/${id}`, data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });

export const removeScheduleAreas = ids => () => api
    .delete('/schedule-areas', { data: { ids } })
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data;
    })
    .catch(error => {
        showScheduleAreaError(error);
        return Promise.reject(error);
    });
